import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { PregnancyService } from '../app/pregnancy.service';
import { PatientsService } from '../app/patients.service';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Measure } from './measurements/meaure';
import { Subject, Subscription, BehaviorSubject, forkJoin } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { SafeUrl } from '@angular/platform-browser';
import { LoginService } from './login.service';
import { CommerrorService } from './commerror.service';
import { ReconnectingSocket, socketOrigin } from './reconnecting-socket';
import moment from 'moment';
import { formatDate } from '@angular/common';

const PREGNANCY_MAX_WEEKS = 40;
// matches CONSENT_VALID_DAYS in the API's letter.controller
const CONSENT_VALID_DAYS = 3;

@Injectable({
  providedIn: 'root',
})
export class ExamsService implements OnDestroy {
  searchReport;
  pregId: number;
  examID: number;
  CreationTime: string;
  isClosed = false;
  LinkSent = false;
  debounce = 500;
  table: string;
  ExamType: string;
  IgnoreFetus = false;
  isGastro = false;
  GASTRO = ['Colonoscopy', 'Gastroscopy', 'Sigmoidoscopy'];
  private Fetus = 1;
  public dataReceived$: Subject<void> = new Subject<void>();
  public fetusChange$: Subject<number> = new Subject<number>();
  public formLoaded$: Subject<void> = new Subject<void>();
  public examLoaded$: Subject<void> = new Subject<void>();
  public mediaArrived$: Subject<string> = new Subject<string>();
  public consentSaved$: Subject<any> = new Subject<any>();
  private continueExamSource = new Subject<boolean>();

  continueExam$ = this.continueExamSource.asObservable();

  stopRecording: SafeUrl;
  ShowSRs = false;
  SRList: number[];
  AWLID: number;
  AWLlmp: Date;
  public Defaults: number;
  public PregCopied: boolean;
  public isForm: boolean;
  public weightAssAll: any;
  weightSub: Subscription;
  formSubs: Subscription[] = [];
  changedTitle = false;
  titleChange: Subject<boolean> = new Subject<boolean>();
  newTitle = '';
  CustomTitlesChanged = new Subject<any>();
  ws: ReconnectingSocket;

  CustomTitles: any;
  newTitleItem: UntypedFormGroup;
  disableSaveTitle = false;
  signed = false;
  public OpenerName: string;
  public printAllMeas = new UntypedFormControl(true);
  switchNT = false;
  switchOvaries = false;
  addNT = false;
  NTAdd$ = new Subject();
  concentLoaded$ = new Subject();
  concentForm;
  pregnancies;
  _saving = false;
  _save_queue = [];
  openNewExam = false;
  awaitPrintHistory: boolean = false;
  examsUsMode = [
    'Early',
    '2nd/3rd',
    'Weight Assessment',
    'Late',
    'Third Scan',
    'Specialized',
    'Tech Exam',
    'CVS',
    'Amniocentesis',
  ];

  // Consent Form:
  consentExamType: string = '';
  consentDocUID: number;
  consentPractitioner: string = '';
  loadPrevDocSign: boolean = false;
  modality: string;

  audio = new Audio('../assets/sounds/chime.mp3');

  public isEitherLMPDataMissing: boolean = false;

  private isEitherLMPDataMissingSource = new BehaviorSubject<boolean>(false);
  public isEitherLMPDataMissing$ = this.isEitherLMPDataMissingSource.asObservable();

  public setEitherLMPDataMissing(value: boolean): void {
    this.isEitherLMPDataMissing = value;
    this.isEitherLMPDataMissingSource.next(value);
  }

  public shouldAutoFocus$: Subject<boolean> = new Subject<boolean>();
  public shouldAutoFocus: boolean = false;

  public shouldTranslate$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private fb: UntypedFormBuilder,
    private http: HttpClient,
    private router: Router,
    public ps: PregnancyService,
    public patServ: PatientsService,
    private sanitizer: DomSanitizer,
    private login: LoginService,
    private ce: CommerrorService
  ) {
    this.ps.Purpose.valueChanges
      .pipe(debounceTime(this.debounce), distinctUntilChanged())
      .subscribe((data) => {
        this.saveVals('PurposeOfExam', this.ps.Purpose.value, false, 'exams');
      });
    this.ps.Consultation.valueChanges
      .pipe(debounceTime(this.debounce), distinctUntilChanged())
      .subscribe(() => {
        this.saveVals('Consultation', this.ps.Consultation.value, false, 'exams');
      });
    this.weightSub = this.fetusChange$.subscribe((res) => {
      this.getAllWeightAssByPre(this.ps.pregID, this.CreationTime, res);
    });
    // this service is a singleton, so per-patient consent state has to be dropped on a switch
    this.patServ.patientChanged$.subscribe(() => {
      this.concentForm = null;
      this.pregnancies = null;
    });
    this.newTitleItem = this.fb.group({
      AutoIndex: new UntypedFormControl(),
      UID: new UntypedFormControl(),
      GID: new UntypedFormControl(),
      Title: new UntypedFormControl(),
      Creation: new UntypedFormControl(),
      isUpdate: new UntypedFormControl(),
    });
    this.CustomTitlesChanged.subscribe((data) => {
      this.CustomTitles = data;
      this.disableSaveTitle = this.CustomTitles.length >= 8;
    });
  }
  getCustomTitles() {
    this.http.get(`/api/newExams/getCustomTitle`).subscribe((data: any) => {
      this.CustomTitlesChanged.next(data);
    });
  }

  saveNewTitle(GID: number, update: boolean) {
    if (!this.disableSaveTitle) {
      this.newTitleItem
        .get('isUpdate')
        .patchValue(this.newTitleItem.get('AutoIndex').value !== null);
      this.newTitleItem.get('GID').patchValue(GID);
      this.http
        .post('/api/newExams/saveCustomTitle', { newTitle: this.newTitleItem.value })
        .subscribe((data: any) => {
          if (data.message === 'ok') {
            this.getCustomTitles();
            this.newTitleItem.reset({ emitEvent: false });
          }
        });
    }
  }
  resetTitleItem() {
    this.newTitleItem.reset({ eventEmit: false });
  }
  getTitle(index: number) {
    var title = '';
    this.CustomTitles.forEach((c: any) => {
      if (c.AutoIndex === index) {
        this.newTitleItem.patchValue(c);
      }
    });
  }
  deleteTitle(index: number) {
    this.http.delete(`/api/newExams/title/${index}`).subscribe((data: any) => {
      if (data.message === 'ok') {
        this.getCustomTitles();
        this.newTitleItem.reset({ emitEvent: false });
      }
    });
  }
  ngOnDestroy() {
    this.weightSub.unsubscribe();
  }

  getExams(patid: string) {
    return this.http.get('/api/exams', {
      params: { PID: patid, uid: this.login.doctor, ID: this.patServ.getPat().ID },
    });
  }

  getDefaults() {
    return this.http.get('/api/defaults');
  }

  getEndometriumHistory() {
    const pid = this.patServ.getPat()?.PID;
    return this.http.get<{ MeasDate: string; Endometrial: number; EndoStripe: number | null }[]>(
      `/api/newExams/endometrium-history/${pid}`,
      {
        params: { examID: String(this.examID) },
      },
    );
  }

  getCervicalLengthHistory() {
    const pid = this.patServ.getPat()?.PID;
    return this.http.get<{ MeasDate: string; Cervical: number; Funneling: number | null }[]>(
      `/api/newExams/cervical-history/${pid}`,
      {
        params: { examID: String(this.examID) },
      },
    );
  }

  getPrintHistoryOptions() {
    return this.http.get<{
      PrintCervicalHistory: boolean;
      PrintEndoHistory: boolean;
      PrintConsultation?: boolean;
    }>(`/api/newExams/print-history/${this.examID}`);
  }

  savePrintHistoryOptions(options: {
    PrintCervicalHistory?: boolean;
    PrintEndoHistory?: boolean;
    PrintConsultation?: boolean;
  }) {
    return this.http.put(`/api/newExams/print-history/${this.examID}`, options);
  }


  getDefaultTable() {
    return this.http.get('/api/default-table');
  }

  setFetus(fetusnum: number) {
    let changed = false;
    if (fetusnum != this.Fetus) changed = true;
    this.Fetus = fetusnum;
    if (changed) this.fetusChange$.next(fetusnum);
  }

  getFetus(): number {
    return this.Fetus;
  }

  getSRs() {
    this.http.get('/api/srlist/' + this.examID).subscribe(
      (data: number[]) => {
        this.SRList = data;
        if (this.SRList.length > 0) this.ShowSRs = true;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getSR(sr: number) {
    return this.http.get('/api/getsr/' + sr, { responseType: 'text' });
  }

  setForm() {
    switch (this.ExamType) {
      case 'Consultation Letter':
        this.isForm = true;
        break;
      default:
        this.isForm = false;
        break;
    }
  }

  startExam(
    name: string,
    patid: number,
    tz: string,
    AWL: number = null,
    lmp: Date = null,
    concent = null,
    changedExamTitle: string = null
  ) {
    this.ExamType = name;
    this.isGastro = this.GASTRO.includes(name);
    this.setForm();
    this.http
      .post('/api/openexam', {
        PID: patid,
        ID: tz,
        ExamType: name,
        AWLID: AWL,
        ChangedExamTitle: changedExamTitle,
      })
      .subscribe(
        (data) => {
          this.pregId = data['pregnanciesbasic']['AutoIndex'];
          this.examID = data['exam']['AutoIndex'];

          // concentForm is a singleton and survives patient switches — never adopt another's
          const consentMatchesPatient = !concent?.PID || concent.PID == patid;
          if (concent && this.login.premissions.Consent && consentMatchesPatient) {
            this.concentForm = concent;
            this.concentForm.ExamID = this.examID;
            this.concentForm.PregID = this.pregId;
            if (this.ExamType === 'Gynecology') {
              this.saveGynForm(true);
              console.log('this.saveGynForm(true)');
            } else {
              this.saveForm(true);
              console.log('this.saveForm(true)');
            }
          }
          if (
            this.ExamType !== 'Consultation Letter' &&
            (!this.concentForm || !this.concentForm.ExamID) &&
            this.login.premissions.Consent
          )
            this.setConcentExmID()?.subscribe(() => {
              const form = this.concentForm;
              if (form) {
                form['ExamID'] = this.examID ?? null;
                form['PregID'] = this.pregId ?? null;
              }
            });

          this.changedTitle = false;
          this.newTitle = null;

          // Set the changed title if provided
          if (data['exam']['ChangedExamTitle']) {
            this.changedTitle = true;
            this.newTitle = data['exam']['ChangedExamTitle'];
          }

          this.switchNT = false;
          this.switchOvaries = false;
          this.addNT = false;
          this.Defaults = null;
          this.setPurpose('');
          this.ps.Purpose.enable({ emitEvent: false });
          this.setConsultation('');
          this.ps.Consultation.enable({ emitEvent: false });
          this.CreationTime = data['exam']['CreationTime'];
          if (
            name != 'Follicles' &&
            name != 'Gynecology' &&
            !this.login.isCardio &&
            patid > 0 &&
            !this.isForm &&
            !this.login.isGastro
          ) {
            this.ps.setPreg(data['pregnanciesbasic'], false, false);
            this.ps.setExamID(this.examID, this.CreationTime);
          }
          this.isClosed = false;
          this.Fetus = 1;
          this.signed = false;

          this.AWLlmp = lmp;
          this.router.navigate(['/exam']);
          this.AWLID = AWL;
          this.examLoaded$.next(void 0);
          if (
            this.login.localServer &&
            (!this.login.lmp_in_mwl || name == 'Follicles' || name == 'Gynecology')
          )
            this.relayWorklist();
          this.openSocket();
        },
        (error) => {
          // do this part later
          console.log(error);
        }
      );
  }
  setConcentExmID() {
    if (this.concentForm && this.concentForm.ExamType == this.ExamType)
      return this.http.post('/api/letters/saveExamID', {
        examID: this.examID,
        pregID: this.pregId,
        concentID: this.concentForm.AutoIndex,
      });
    else
      return this.http.post('/api/letters/saveExamID', {
        examID: this.examID,
        ExamType: this.ExamType,
        PregID: this.pregId,
      });
  }

  private setPurpose(value) {
    this.ps.Purpose.setValue(value, { emitEvent: false });
  }

  private setConsultation(value) {
    this.ps.Consultation.setValue(value || '', { emitEvent: false });
  }

  // Exam-row text fields (Purpose, Consultation) follow the exam's closed state
  private setExamTextFieldsEnabled(enabled: boolean) {
    for (const control of [this.ps.Purpose, this.ps.Consultation]) {
      if (enabled) control.enable({ emitEvent: false });
      else control.disable({ emitEvent: false });
    }
  }

  // The AI writes straight to the exam/pregnancy rows and section tables, so re-read them
  // into the open forms (the pregnancy form may be sourced from the exam row when PregCopied).
  reloadAfterAI() {
    const pid = this.patServ.getPat().PID;
    this.http
      .get('/api/exam', {
        params: {
          ExamID: this.examID.toString(),
          PregIndex: this.pregId ? this.pregId.toString() : '',
          PID: pid.toString(),
          viewonly: 'y',
        },
      })
      .subscribe({
        next: (data) => {
          this.setPurpose(data['exam']['PurposeOfExam']);
          this.setConsultation(data['exam']['Consultation']);
          if (this.pregId)
            this.ps.setPreg(
              data['exam']['PregCopied'] ? data['exam'] : data['pregnancy'],
              false,
              this.isClosed
            );
          this.refreshCurrentForm();
        },
        error: (error) => console.log(error),
      });
  }

  // re-run the last section load (placenta, cns, summary...) so the visible tab shows the AI's values
  private lastFill: () => void = null;
  refreshCurrentForm() {
    if (this.lastFill) this.lastFill();
  }

  goExam(preg, exam, etype: string, viewonly = false) {
    if (!exam) {
      return;
    }
    if (preg) this.pregId = preg.AutoIndex;
    else this.pregId = null;
    this.examID = exam.AutoIndex;

    this.Fetus = 1;
    this.router.navigate(['/exam']);
    let pid = this.patServ.getPat().PID;
    this.ExamType = etype;
    this.isGastro = this.GASTRO.includes(etype);
    if (this.ExamType == 'Emergency Room') viewonly = true;

    // Only doctors, visiting doctors and techs may edit an exam. Every other role
    // (secretaries, etc.) is forced to view-only up front — regardless of clinic
    // separation or whether the patient PID resolved — so editing can't be bypassed.
    const isEditor =
      this.login.userType == 'doctor' ||
      this.login.userType == 'visitingdoc' ||
      this.login.userType == 'tech';
    if (!isEditor) viewonly = true;

    this.setForm();
    this.http
      .get('/api/exam', {
        params: {
          ExamID: this.examID.toString(),
          PregIndex: this.pregId ? this.pregId.toString() : '',
          PID: pid.toString(),
          viewonly: viewonly ? 'y' : 'n',
        },
      })
      .subscribe(
        (data) => {
          this.CreationTime = data['exam']['CreationTime'];
          this.ExamType = data['exam']['ExamType'];
          this.LinkSent = data['exam']['LinkSent'];
          this.isGastro = this.GASTRO.includes(this.ExamType);
          this.changedTitle = data['exam']['Changed'];
          this.newTitle = data['exam']['ChangedExamTitle'];
          this.switchNT = this.changedTitle && this.newTitle == '1st & NT';
          this.addNT = this.changedTitle && this.newTitle == 'Early & NT';
          this.switchOvaries = data['exam']['addOvaries'];
          this.setPurpose(data['exam']['PurposeOfExam']);
          this.setConsultation(data['exam']['Consultation']);
          this.isClosed = false;
          if (data['exam']['printAllMeas'] !== null) {
            this.printAllMeas.patchValue(data['exam']['printAllMeas']);
          } else {
            this.printAllMeas.patchValue(true);
          }
          if (data['exam']['AWLID']) this.AWLID = data['exam']['AWLID'];
          this.Defaults = data['exam']['EDefault'];

          var closedd;
          if (data['exam']['ClosedDate']) closedd = new Date(data['exam']['ClosedDate']);
          if (data['exam']['OpenerName']) this.OpenerName = data['exam']['OpenerName'];
          else this.OpenerName = null;
          if (data['exam']['ClosedDate']) this.signed = true;
          else this.signed = false;

          if (
            // Non-editor roles may never edit — view-only regardless of pid/separation.
            !isEditor ||
            (pid > 0 &&
              ((!this.login.isCardio && (viewonly || this.examClosed())) ||
                (this.login.isCardio &&
                  data['exam']['ClosedDate'] &&
                  this.examClosed(closedd))))
          ) {
            this.isClosed = true;
            this.setExamTextFieldsEnabled(false);
          } else {
            this.setExamTextFieldsEnabled(true);
            //get worklist for local server
            if (
              this.login.localServer &&
              (!this.login.lmp_in_mwl ||
                this.ExamType == 'Follicles' ||
                this.ExamType == 'Gynecology')
            )
              this.relayWorklist();
            this.openSocket();
          }
          if (preg)
            this.ps.setPreg(
              data['exam']['PregCopied'] ? data['exam'] : data['pregnancy'],
              false,
              this.isClosed
            );
          this.PregCopied = data['exam']['PregCopied'];

          this.examLoaded$.next(void 0);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  goExamAdvancedSearch(exam, viewonly = true, supportCenter = false) {
    if (!exam) {
      return;
    }

    this.examID = supportCenter ? exam.AutoIndex : exam.examID;
    this.pregId = exam.PregIndex;

    this.Fetus = 1;
    this.router.navigate(['/exam']);
    let pid = exam.PID;
    this.ExamType = exam.ExamType;

    (this.http
      .get('/api/exam', {
        params: {
          ExamID: this.examID.toString(),
          PregIndex: this.pregId ? this.pregId.toString() : '',
          PID: pid.toString(),
          viewonly: 'y',
        },
      })
      .subscribe((data) => {
        this.CreationTime = data['exam']['CreationTime'];
        this.ExamType = data['exam']['ExamType'];
        this.LinkSent = data['exam']['LinkSent'];
        this.isGastro = this.GASTRO.includes(this.ExamType);
        this.changedTitle = data['exam']['Changed'];
        this.newTitle = data['exam']['ChangedExamTitle'];
        this.switchNT = this.changedTitle && this.newTitle == '1st & NT';
        this.addNT = this.changedTitle && this.newTitle == 'Early & NT';
        this.switchOvaries = data['exam']['addOvaries'];
        this.setPurpose(data['exam']['PurposeOfExam']);
        this.setConsultation(data['exam']['Consultation']);
        this.isClosed = false;
        if (data['exam']['printAllMeas'] !== null) {
          this.printAllMeas.patchValue(data['exam']['printAllMeas']);
        } else {
          this.printAllMeas.patchValue(true);
        }
        if (data['exam']['AWLID']) this.AWLID = data['exam']['AWLID'];
        this.Defaults = data['exam']['EDefault'];

        var closedd;
        if (data['exam']['ClosedDate']) closedd = new Date(data['exam']['ClosedDate']);
        if (data['exam']['OpenerName']) this.OpenerName = data['exam']['OpenerName'];
        else this.OpenerName = null;
        if (data['exam']['ClosedDate']) this.signed = true;
        else this.signed = false;

        if (
          pid > 0 &&
          ((!this.login.isCardio && (viewonly || this.examClosed())) ||
            (this.login.userType != 'doctor' &&
              this.login.userType != 'visitingdoc' &&
              this.login.userType != 'tech') ||
            (this.login.isCardio && data['exam']['ClosedDate'] && this.examClosed(closedd)))
        ) {
          this.isClosed = true;
          this.setExamTextFieldsEnabled(false);
        } else {
          this.setExamTextFieldsEnabled(true);
          //get worklist for local server
          if (
            this.login.localServer &&
            (!this.login.lmp_in_mwl ||
              this.ExamType == 'Follicles' ||
              this.ExamType == 'Gynecology')
          )
            this.relayWorklist();
          this.openSocket();
        }
        if (exam)
          this.ps.setPreg(
            data['exam']['PregCopied'] ? data['exam'] : data['pregnancy'],
            false,
            this.isClosed
          );
        this.PregCopied = data['exam']['PregCopied'];

        this.examLoaded$.next(void 0);
      }),
      (error) => {
        console.log(error);
      });
  }

  fillForm(
    form: UntypedFormGroup,
    table: string,
    savePregID = false,
    ignoreFetus = false,
    nosave = [],
    allowSaveWhenClosed = []
  ) {
    this.lastFill = () => this.fillForm(form, table, savePregID, ignoreFetus, nosave, allowSaveWhenClosed);
    this.table = table;
    let params = { table: table, ExamID: this.examID.toString() };
    if (!ignoreFetus && this.ExamType !== 'Pediatric Echo') params['fetus'] = this.Fetus.toString();
    this.IgnoreFetus = ignoreFetus;
    var s: Subscription;
    let oldSubs = this.formSubs;
    this.formSubs = [];
    setTimeout(() => {
      while ((s = oldSubs.pop())) s.unsubscribe();
    }, 700); //wait for debounce to expire before unsubscribe
    let f = this.http.get('/api/get', { params: params });
    f.subscribe(
      (data) => {
        if (!data.hasOwnProperty('empty')) {
          for (let key in data) {
            if (form.get(key)) {
              if (data[key] !== null)
                form.get(key).setValue(data[key], { emitEvent: false }); //null ruins formcontrol
              else {
                if (form.get(key).value != '') form.get(key).setValue('', { emitEvent: false });
              }
            }
          }
        } else form.reset({ emitEvent: false });
        for (let key in form.controls) {
          if (this.isClosed && !allowSaveWhenClosed.includes(key)) {
            form.get(key).disable();
          } else if (!nosave.includes(key))
            this.formSubs.push(
              form.controls[key].valueChanges
                .pipe(debounceTime(this.debounce), distinctUntilChanged())
                .subscribe((data) => {
                  this.saveVals(key, form.get(key).value, savePregID, table);
                })
            );
        }

        this.formLoaded$.next();
      },
      (error) => {
        console.log(error);
      }
    );
    return f;
  }

  fillUngrouped(formarray: UntypedFormControl[], table: string, use_queue = true) {
    this.lastFill = () => this.fillUngrouped(formarray, table, use_queue);
    this.IgnoreFetus = false;
    this.table = table;
    var s: Subscription;
    let oldSubs = this.formSubs;
    this.formSubs = [];
    setTimeout(() => {
      while ((s = oldSubs.pop())) s.unsubscribe();
    }, 700);
    let f = this.http.get('/api/get', {
      params: { table: table, fetus: this.Fetus.toString(), ExamID: this.examID.toString() },
    });
    f.subscribe(
      (data) => {
        if (!data.hasOwnProperty('empty')) {
          for (let key in data) {
            if (formarray.hasOwnProperty(key)) {
              if (data[key] !== null) formarray[key].setValue(data[key], { emitEvent: false });
              else formarray[key].setValue('', { emitEvent: false }); //empty string ruins formcontrol using dumb hack so things work in anatomy form
            }
          }
        } else {
          //empty - reset everything
          for (let key in formarray) formarray[key].reset('', { emitEvent: false });
        }
        for (let key in formarray) {
          if (this.isClosed) {
            formarray[key].disable();
          } else {
            this.formSubs.push(
              formarray[key].valueChanges
                .pipe(debounceTime(this.debounce), distinctUntilChanged())
                .subscribe((data) => {
                  this.saveVals(key, formarray[key].value, false, this.table, use_queue);
                })
            );
          }
        }
        this.formLoaded$.next();
      },
      (error) => {
        console.log(error);
      }
    );
    return f;
  }

  setTable(tbl: string) {
    this.table = tbl;
    this.IgnoreFetus = false;
  }

  saveVals(key: string, value: any, preg = false, table = this.table, use_queue = true) {
    let p = this.patServ.getPat();
    let fetusNum;

    if (this.ExamType === 'Pediatric Echo') {
      fetusNum = null;
    } else {
      fetusNum = this.IgnoreFetus ? '1' : this.getFetus().toString();
    }

    let values = {
      table: table,
      indexvalue: this.examID,
      PID: p.PID,
      ID: p.ID,
      CreationTime: this.CreationTime,
      field: key,
      value: value,
      fetus: fetusNum,
    };
    if (preg) {
      values['Preg'] = this.ps.pregID;
    }
    if (use_queue && this._saving) {
      this._save_queue.push(values);
    } else {
      this.savePost(values);
    }
  }

  savePost(values) {
    if (values.table === 'GYNgeneral' && values.field === 'LMP') {
      values.value = formatDate(values.value, 'yyyy-MM-dd', 'en-US');
    }
    this._saving = true;
    this.http.post('/api/save', values).subscribe(
      (data) => {
        console.log(data);
        this._saving = false;
        this.checkQueue();
        //later on add observer for saves/errors
      },
      (error) => {
        // do this part later
        console.log(error);
        this._saving = false;
        this.checkQueue();
      }
    );
  }

  checkQueue() {
    if (this._save_queue.length > 0 && !this._saving) {
      this.savePost(this._save_queue.shift());
    }
  }

  getUpDateConcent() {
    return this.http.get(`api/letters/concent/${this.concentForm['AutoIndex']}`);
  }

  getFindingsOptions() {
    return this.http.get(`api/Findings`);
  }

  async ExamFindings() {
    try {
      return await this.http.get(`api/Findings/exam/${this.examID}`).toPromise();
    } catch (error) {
      console.error('Error ExamFindings:', error);
      return [];
    }
  }

  addFinding(finding) {
    const body = { finding, examID: this.examID, PID: this.patServ.getPat().PID };
    return this.http.post('/api/Findings/exam', body);
  }

  removeFinding(finding) {
    return this.http.delete('/api/Findings/exam/' + this.examID + '/' + finding.AutoIndex);
  }

  getConcentForExam() {
    let pid = this.patServ.getPat().PID;
    return this.http.get(`api/letters/concentForExamID/${this.examID}/${pid}`);
  }
  examGA(ct = this.CreationTime): string {
    try {
      //return this.ps.getGA();
      if (ct == this.CreationTime) return this.ps.getGA();
      let examdays = Measure.WeekToDays(this.ps.getGA());
      let edate = new Date(ct); //the mssql comes out in a different format
      let gaexamdays =
        examdays -
        (new Date(this.CreationTime).getTime() - edate.getTime()) / (1000 * 24 * 60 * 60);
      return Measure.DaysToWeeks(gaexamdays);
    } catch {
      return '';
    }
  }

  israelDate(date) {
    const jsDate = moment(date).toDate();
    const day = jsDate.getDate();
    const month = jsDate.getMonth() + 1;
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours();
    const minutes = jsDate.getMinutes();
    const seconds = jsDate.getSeconds();

    return `${year}-${this.padZero(month)}-${this.padZero(day)} ${this.padZero(
      hours
    )}:${this.padZero(minutes)}:${this.padZero(seconds)}`;
  }

  loginMissing() {
    if (!this.examID) this.router.navigate(['/']);
  }

  record(start: boolean) {
    this.http.get('/api/record/' + this.examID + '/' + (start ? 'start' : 'stop')).subscribe(
      (data) => {},
      (err) => {
        console.warn(err);
      }
    );
  }

  exitExam() {
    this.patServ.getPat().ID !== 'default'
      ? (this.awaitPrintHistory = true)
      : (this.awaitPrintHistory = false);
    if (!this.isClosed && this.patServ.getPat().ID != 'default') {
      this.awaitPrintHistory = true;
      this.http
        .get('/api/examexit/' + this.examID + '/' + (this.AWLID ? this.AWLID : '0'))
        .subscribe();
      let lang = this.login.printLang ? this.login.printLang : 'he-IL';
      if (this.ExamType != 'Emergency Room') this.awaitPrintHistory = true;
      this.http
        .get(
          '/api/printpdf/' +
            this.examID +
            '/' +
            this.patServ.getPat().PID +
            '/' +
            lang +
            '/y/n/simple/2/n'
        )
        .subscribe(
          () => {
            this.awaitPrintHistory = false;
          },
          (err) => {
            this.awaitPrintHistory = false;
            console.log(err);
          }
        );
    }

    this.AWLID = null;

    if (this.GASTRO.includes(this.ExamType)) {
      this.patServ.AWLStatus = 'All';
      this.patServ.exitFromGastroExam.next(true);
    }
    this.closeSocket();

    if (this.isClosed) {
      this.awaitPrintHistory = false;
    }
  }

  savePrintALl() {
    this.saveVals('printAllMeas', this.printAllMeas.value, false, 'exams');
  }

  deleteExam(examid: number, awlid: number, table = null) {
    this.http
      .delete('/api/exam/' + examid + '/' + (awlid ? awlid : 'none') + '/' + table)
      .subscribe();
  }

  getLastSummary() {
    return this.http.get(
      '/api/lastdiagnosis/' +
        this.patServ.getPat().PID +
        '/' +
        this.examID +
        '/' +
        (this.ExamType == 'Gynecology' ? 'y' : 'n')
    );
  }

  getLastHistory(gyn = false) {
    return this.http.get(
      '/api/lastmedhistory/' +
        this.patServ.getPat().PID +
        '/' +
        this.examID +
        '/' +
        (gyn ? 'y' : 'n')
    );
  }

  getLastHistoryFromClosedPreg() {
    return this.http.get(
      '/api/lastmedhistoryclosed/' + this.patServ.getPat().PID + '/' + this.examID
    );
  }

  sendLink(phone: string) {
    return this.http.get('/api/sendlink', {
      params: {
        examid: this.examID.toString(),
        pnumber: phone,
        isLetter: this.ExamType === 'Consultation Letter' ? true : false,
      },
    });
  }

  sendLinkConcent(phone: string, concentForm = null) {
    return this.http.get('/api/letters/sendlinkconcent', {
      params: {
        examID: this.concentForm['ExamID'],
        ConcentID: this.concentForm['AutoIndex'],
        pnumber: phone,
        isConsent: true,
      },
    });
  }

  sendLinkConcentGYN(phone: string, concentForm = null) {
    return this.http.get('/api/letters/sendlinkconcent', {
      params: {
        examID: this.concentForm['ExamID'],
        ConcentID: this.concentForm['AutoIndex'],
        pnumber: phone,
        isConsent: false,
        isGynConsent: true,
      },
    });
  }

  setDefaults() {
    return this.http.get('/api/applydefaults/' + this.examID);
  }

  relayWorklist() {
    this.http.get('/api/worklist/' + this.examID).subscribe(
      (data) => {
        if (data['worklist'])
          this.http
            .post('http://localhost:8088/worklist', { worklist: data['worklist'] })
            .subscribe(
              (data) => {},
              (err) => {
                console.log(err);
              }
            );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  examSearch(fdate, tdate, examtype, uid, page?: number, pageSize?: number) {
    var fd;
    var td;
    try {
      fd = fdate._i.year + '-' + (fdate._i.month + 1) + '-' + fdate._i.date;
      td = tdate._i.year + '-' + (tdate._i.month + 1) + '-' + tdate._i.date;
    } catch {
      fd = fdate.toISOString().slice(0, 19).split('T')[0];
      td = tdate.toISOString().slice(0, 19).split('T')[0];
    }
    let echosen = [];
    for (let e in examtype) {
      if (examtype[e]) echosen.push(e);
    }
    const params: any = { from: fd, until: td, exam: JSON.stringify(echosen), uid: uid };
    if (page != null && pageSize != null) {
      params.page = page;
      params.pageSize = pageSize;
    }
    return this.http.get('/api/examsearch', { params });
  }

  reportSearch(format: string, filter: string, from, until, uid) {
    const parsedFrom = this.parseDate(from);
    const parsedUntill = this.parseDate(until);
    return this.http.get('/api/stats/report', {
      params: { format, filter, from: parsedFrom, until: parsedUntill },
    });
  }

  parseDate(date) {
    const ms = moment(date).valueOf();
    const jsDate = new Date(ms);
    const day = jsDate.getDate();
    const month = jsDate.getMonth() + 1;
    const year = jsDate.getFullYear();
    return `${year}-${month}-${day}`;
  }

  parseConsentDate(date) {
    const jsDate = moment(date).toDate();
    const day = jsDate.getDate();
    const month = jsDate.getMonth() + 1;
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours();
    const minutes = jsDate.getMinutes();
    const seconds = jsDate.getSeconds();

    return `${year}-${this.padZero(month)}-${this.padZero(day)} ${this.padZero(
      hours
    )}:${this.padZero(minutes)}:${this.padZero(seconds)}`;
  }

  padZero(number) {
    return number < 10 ? '0' + number : number;
  }

  parseDateDayMonthYear(date) {
    const ms = moment(date).valueOf();
    const jsDate = new Date(ms);
    const day = jsDate.getDate();
    const month = jsDate.getMonth() + 1;
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  }

  getAllWeightAssByPre(pregID: number, examTime: any, NumFetuses: any) {
    var temp: any = [];
    return this.http.get(
      `/api/newExams/getAllWeightAss/${pregID}/${examTime}/${NumFetuses}/${this.ExamType}`
    );
  }

  getAllWeightData() {
    return this.weightAssAll ? this.weightAssAll.slice() : [];
  }

  examGAByCreation(creationTime): string {
    try {
      //return this.ps.getGA();
      // if(creationTime == this.CreationTime)
      //   return this.ps.getGA();
      let examdays = Measure.WeekToDays(this.ps.getGA());
      let edate = new Date(creationTime); //the mssql comes out in a different format
      let gaexamdays =
        examdays -
        (new Date(this.CreationTime).getTime() - edate.getTime()) / (1000 * 24 * 60 * 60);
      return Measure.DaysToWeeks(gaexamdays);
    } catch {
      return '';
    }
  }

  getClosing() {
    return this.http.get('/api/cardio/closing/' + this.examID);
  }

  signExam(signer) {
    return this.http.post('/api/cardio/close/' + this.examID, { signer: signer });
  }

  numOgFeatus() {
    // return this.ps.pregForm.value;
    return this.Fetus;
  }
  changeTitle(str: any, changedTitle?: boolean) {
    this.http
      .post(`/api/newExams/changeTitle`, {
        patient: this.patServ.getPat(),
        examID: this.examID,
        oldTitle: this.ExamType,
        newExamTitle: str,
        Changed: this.changedTitle || changedTitle,
      })
      .subscribe((res: any) => {
        this.newTitle = str;
        this.titleChange.next(this.changedTitle || changedTitle);
      });
  }

  switchTONTExam() {
    if (this.ExamType == '1st') {
      this.switchNT = !this.switchNT;
      this.saveVals('Changed', this.switchNT, false, 'exams');
      this.saveVals('ChangedExamTitle', '1st & NT', false, 'exams');
      this.changedTitle = this.switchNT;
      this.newTitle = '1st & NT';
    } else {
      this.addNT = !this.addNT;
      this.saveVals('Changed', this.addNT, false, 'exams');
      this.saveVals('ChangedExamTitle', 'Early & NT', false, 'exams');
      this.changedTitle = this.addNT;
      this.newTitle = 'Early & NT';
      this.NTAdd$.next(undefined);
    }

    // this.saveVals('printAllMeas', this.printAllMeas.value, false, 'exams');
  }
  addOvaries() {
    this.switchOvaries = !this.switchOvaries;
    this.http
      .post('/api/newExams/addOvaries', { ExamID: this.examID, data: this.switchOvaries })
      .subscribe((data) => {
        console.log(data);
      });
  }

  getDisk() {
    return this.http.get('/api/disk/' + this.examID);
  }

  openSocket() {
    // Always start clean: the socket is bound to the exam it was opened for.
    this.closeSocket();
    const examID = this.examID;
    this.ws = new ReconnectingSocket(
      () => socketOrigin() + '/api/examsocket/' + examID,
      (ev) => {
        this.mediaArrived$.next(ev.data);
        if (ev.data == 'html') this.getSRs();
        if (this.login.hasImaging && ev.data != 'full') {
          this.audio.play();
        }
      },
      'exam',
      // Media captured while the socket was down - an image, a clip, a full recording - would
      // otherwise not appear until the NEXT capture. After a reconnect the gallery reloads
      // ('resync' is not 'html', so the measurement screens do not re-apply a structured report)
      // and the SR list is re-read.
      (reconnected) => {
        if (!reconnected) return;
        this.mediaArrived$.next('resync');
        this.getSRs();
      }
    );
  }

  closeSocket() {
    if (this.ws) this.ws.close();
    this.ws = null;
  }

  getAllCalForms(pergID) {
    return this.http.get(
      '/api/newExams/getAllCalForms/' + pergID + '/' + this.patServ.getPat().PID
    );
  }

  getConcentForms(pid: Number, AWLStatus = null) {
    return this.http.get('/api/letters/getAllConcentForms/' + pid.toString());
  }

  // AR-24 questionnaires
  getPatientQuestionnaires(pid) {
    return this.http.get('/api/questionnaires/patient/' + pid);
  }

  getAiSummary(examType: string, pid) {
    return this.http.get('/api/questionnaires/ai-summary', {
      params: {
        examType: examType == null ? '' : examType,
        pid: pid == null ? '' : pid,
        examId: this.examID == null ? '' : this.examID,
      },
    });
  }

  saveForm(save = false) {
    if (this.examID) this.concentForm.ExamID = this.examID;
    // if (this.pregId) this.concentForm.PregID = this.pregId;
    if (
      this.concentForm.PregID == '' &&
      this.pregnancies.length > 0 &&
      !this.pregnancies[0].ClosedDate
    )
      this.concentForm.PregID = this.pregnancies[0].AutoIndex;
    if (this.login.userType === 'secretary') {
      this.concentForm.UID = this.consentDocUID;
    }

    if (save)
      this.http
        .post('/api/letters/saveConcentForm', {
          form: this.concentForm,
          pat: this.patServ.getPat(),
          pregID:
            this.pregnancies.length > 0 &&
            !this.pregnancies[0].ClosedDate &&
            !(this.concentForm.ExamType == 'Gynecology')
              ? this.pregnancies[0].AutoIndex
              : null,
          pastTermAcknowledged: this.openNewExam,
        })
        .subscribe({
          next: (data) => {
            this.concentForm = data;
            this.login.concentCount = this.login.concentCount + 1;
            this.dataReceived$.next(void 0);
          },
          error: (err) => this.handleConsentSaveError(err),
        });
  }

  private pregnancyBaseDate(preg: any): Date {
    for (const value of [preg.LMP, preg.LMP_US, preg.Ovulation, preg.CreationTime]) {
      if (!value) {
        continue;
      }
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date;
      }
    }
    return null;
  }

  // Usable while no exam owns it and inside the reuse window — signed ones still count.
  isConsentUsable(consent: any): boolean {
    if (!consent || consent.ExamID || consent.Deleted) {
      return false;
    }
    const created = new Date(consent.CreationTime);
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - CONSENT_VALID_DAYS);
    return created >= cutoff;
  }

  // Newest first, so a repeat visit picks up the latest consent rather than the oldest row.
  usableConsents(consents: any[], examType: string): any[] {
    return (consents || [])
      .filter((consent) => consent.ExamType == examType && this.isConsentUsable(consent))
      .sort((first, second) => second.AutoIndex - first.AutoIndex);
  }

  private isPregnancyPastTerm(preg: any): boolean {
    const baseDate = this.pregnancyBaseDate(preg);
    if (!baseDate) {
      return false;
    }
    const edd = new Date(baseDate);
    edd.setDate(edd.getDate() + PREGNANCY_MAX_WEEKS * 7);
    return edd < new Date();
  }

  // All of them block — the API resolves the newest open one, so closing just that one repeats.
  pastTermOpenPregnancies(pregnancies: any[]): any[] {
    return (pregnancies || []).filter(
      (preg) => !preg.ClosedDate && this.isPregnancyPastTerm(preg)
    );
  }

  consentPregnancyPastTerm(pregnancies: any[]): boolean {
    return this.pastTermOpenPregnancies(pregnancies).length > 0;
  }

  // Closes every blocking pregnancy in one go; onClosed runs when they are all closed.
  offerPastTermClose(pregIDs: number[], onClosed: () => void) {
    this.ce.showConsentNotice(
      'GUI.errorMessages.consent.title',
      'GUI.errorMessages.consent.pregnancyPastTerm',
      {
        labelKey: 'GUI.errorMessages.consent.closePregnancyAction',
        run: () => this.closePastTermPregnancies(pregIDs, onClosed),
      }
    );
  }

  private closePastTermPregnancies(pregIDs: number[], onClosed: () => void) {
    forkJoin(pregIDs.map((pregID) => this.ps.closeById(pregID))).subscribe({
      next: () => {
        for (const pregID of pregIDs) {
          this.markPregnancyClosed(pregID);
        }
        onClosed();
      },
      error: () => {
        this.ce.showConsentNotice(
          'GUI.errorMessages.consent.closeFailedTitle',
          'GUI.errorMessages.consent.closeFailedMsg'
        );
      },
    });
  }

  // The list is shared with the components rendering it, so patch it instead of refetching.
  private markPregnancyClosed(pregID: number) {
    const closed = this.pregnancies?.find((preg) => preg.AutoIndex == pregID);
    if (closed) {
      closed.ClosedDate = new Date();
    }
    if (this.pregId == pregID) {
      this.pregId = null;
    }
    if (this.concentForm && this.concentForm.PregID == pregID) {
      this.concentForm.PregID = null;
    }
  }

  private handleConsentSaveError(err: any) {
    if (err?.status !== 400 || err?.error?.code !== 'PREGNANCY_PAST_TERM') {
      return;
    }
    const pregID = err?.error?.pregID;
    if (!pregID) {
      this.ce.showConsentNotice(
        'GUI.errorMessages.consent.title',
        'GUI.errorMessages.consent.pregnancyPastTerm'
      );
      return;
    }
    // One id because the API names only the pregnancy it resolved; the user then saves again.
    this.offerPastTermClose([pregID], () =>
      this.ce.showConsentNotice(
        'GUI.errorMessages.consent.closedTitle',
        'GUI.errorMessages.consent.closedMsg'
      )
    );
  }

  saveGynForm(save = false) {
    if (this.examID) this.concentForm.ExamID = this.examID;
    this.concentForm.PregID = null;
    if (this.login.userType === 'secretary') {
      this.concentForm.UID = this.consentDocUID;
    }

    if (save)
      this.http
        .post('/api/letters/consent-gyn', {
          form: this.concentForm,
          pat: this.patServ.getPat(),
          pregID: null,
        })
        .subscribe((data) => {
          this.concentForm = data;
          this.login.concentCount = this.login.concentCount + 1;
          this.dataReceived$.next(void 0);
        });
  }

  async saveFormPrint(save = false) {
    if (this.examID) {
      this.concentForm.ExamID = this.examID;
    }

    if (
      this.concentForm.PregID === '' &&
      this.pregnancies.length > 0 &&
      !this.pregnancies[0].ClosedDate
    ) {
      this.concentForm.PregID = this.pregnancies[0].AutoIndex;
    }
    if (this.login.userType === 'secretary') {
      this.concentForm.UID = this.consentDocUID;
    }

    if (save) {
      const data = await this.http
        .post('/api/letters/saveConcentForm', {
          form: this.concentForm,
          pat: this.patServ.getPat(),
          pregID:
            this.pregnancies.length > 0 &&
            !this.pregnancies[0].ClosedDate &&
            !(this.concentForm.ExamType == 'Gynecology')
              ? this.pregnancies[0].AutoIndex
              : null,
          pastTermAcknowledged: this.openNewExam,
        })
        .toPromise()
        .catch((err) => {
          this.handleConsentSaveError(err);
          throw err;
        });
      this.consentSaved$.next(undefined);
      this.dataReceived$.next(void 0);
      this.concentForm = data;
      this.login.concentCount = this.login.concentCount + 1;
      return data;
    }
  }

  async saveGynFormPrint(save = false) {
    if (this.examID) {
      this.concentForm.ExamID = this.examID;
    }

    if (
      this.concentForm.PregID === '' &&
      this.pregnancies.length > 0 &&
      !this.pregnancies[0].ClosedDate
    ) {
      this.concentForm.PregID = this.pregnancies[0].AutoIndex;
    }
    if (this.login.userType === 'secretary') {
      this.concentForm.UID = this.consentDocUID;
    }

    if (save) {
      const data = await this.http
        .post('/api/letters/consent-gyn', {
          form: this.concentForm,
          pat: this.patServ.getPat(),
          pregID:
            this.pregnancies.length > 0 &&
            !this.pregnancies[0].ClosedDate &&
            !(this.concentForm.ExamType == 'Gynecology')
              ? this.pregnancies[0].AutoIndex
              : null,
        })
        .toPromise();
      this.consentSaved$.next(undefined);
      this.dataReceived$.next(void 0);
      this.concentForm = data;
      this.login.concentCount = this.login.concentCount + 1;
      return data;
    }
  }

  examClosed(examdate = null): boolean {
    let now = new Date();
    var closure = new Date();
    closure.setHours(3);
    closure.setMinutes(0);
    if (now.getHours() < 3) {
      closure.setDate(closure.getDate() - 1);
    }
    if (!examdate) examdate = new Date(this.CreationTime);
    return closure > examdate;
  }
  public showDefaultButton() {
    const hasDefault =
      this.login.defaultExams &&
      (this.login.defaultExams[this.ExamType] ||
        (this.ExamType === 'Specialized' &&
          (this.login.defaultExams['Specialized'] ||
            (this.login.defaultExams.SpecializedSubTypes &&
              this.login.defaultExams.SpecializedSubTypes[this.newTitle]))));
    return (
      this.login.ishospital &&
      !this.isClosed &&
      hasDefault &&
      this.Defaults == null &&
      this.patServ.currentPatient.ID != 'default'
    );
  }

  public showMissingLMPMsg(page: string) {
    const LMP = this.ps.pregForm.get('LMP').value;
    const LMP_US = this.ps.pregForm.get('LMP_US').value;

    const isMeasurementsPage = page === 'Measurements';
    const isObsDopplerPage = page === 'Obs Doppler';
    const isEitherLMPDataMissing = LMP || LMP_US;

    return !this.isClosed && (isMeasurementsPage || isObsDopplerPage) && !isEitherLMPDataMissing;
  }

  getAllPractitioners() {
    try {
      return this.http.get('/api/consent/practitioners');
    } catch (error) {
      console.error(error);
    }
  }

  async getPrevDocSign() {
    try {
      let body = {
        UID:
          this.login.userType === 'doctor'
            ? this.login.UID
            : this.consentDocUID || this.concentForm.UID,
      };

      const response = await this.http.post('/api/consent/sign', body);
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  fetchModality() {
    return new Promise((resolve, reject) => {
      this.http
        .get('/api/search/getModality', {
          params: { table: 'exams', ExamID: this.examID.toString() },
        })
        .subscribe(
          (data) => {
            this.modality = data['MODALITY'];
            resolve(this.modality); // resolve with this.modality value
          },
          (error) => {
            console.log(error, 'IN fetchModality');
            this.modality = null;
            reject(error); // reject with error value
          }
        );
    });
  }

  getAllTodaysExams(examType: string = '', changedExamTitle?: string) {
    const patientID = String(this.patServ.getPat().ID);
    const examName = String(examType);
    let url = `/api/NewExams/todaysexams?patientID=${patientID}&examType=${examName}`;
    if (changedExamTitle) {
      url += `&changedExamTitle=${encodeURIComponent(changedExamTitle)}`;
    }
    try {
      return this.http.get(url);
    } catch (error) {
      console.error(error);
    }
  }

  continueExam(shouldContinue: boolean) {
    this.continueExamSource.next(shouldContinue);
  }
}
